import React, { useEffect, useState } from "react";
import MobileBottomNav from '../components/layout/MobileBottomNav';
import Sidebar from "../components/layout/Sidebar";

export default function AdvertisementMaster() {
  const [ads, setAds] = useState([]);
  const [isMobile, setIsMobile] = useState(false);
    const [role, setRole] = useState(3);

  const [form, setForm] = useState({
    title: "",
    subtitle: "",
    buttonText: "",
    buttonLink: "",
    adType: "main",
    sortOrder: 0,
    image: null
  });

  const loadAds = async () => {
    const res = await fetch("/api/advertisements");
    const data = await res.json();
    setAds(data.ads || []);
  };

  useEffect(() => {
    loadAds();
  }, []);
 useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 640);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const saveAd = async () => {
    const fd = new FormData();

    Object.keys(form).forEach(key => {
      fd.append(key, form[key]);
    });

    await fetch("/api/advertisements", {
      method: "POST",
      body: fd
    });

    alert("Advertisement Saved");

    loadAds();
  };
  const deleteAd = async (id) => {
    if (!window.confirm("Delete Advertisement?")) return;

    await fetch(`/api/advertisements/${id}`, {
      method: "DELETE"
    });

    loadAds();
  };
 

return (
  <>
   
    <div
      style={{
        display: "flex",
        minHeight: "100vh",
        background: "#f8fafc",
      }}
    >
       {!isMobile && <Sidebar role={role} />}
  <section
    className="admin-users"
    style={{
      padding: "20px",
      overflowY: "auto",
      maxHeight: "calc(100vh - 100px)"
    }}
  >
   
    <header
      className="admin-users-header"
      style={{ marginBottom: "20px" }}
    >
      <h2 style={{ color: "black" }}>
        Advertisement Master
      </h2>
    </header>

    {/* Add Advertisement Form */}

    <div
      style={{
        background: "#fff6f6",
        padding: "20px",
        borderRadius: "10px",
        marginBottom: "25px",
      }}
    >
      <h3>Add Advertisement</h3>
<small style={{ color: "red" }}>
        Main Slider - 600*350 /  Side Banner-150*350
      </small>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit,minmax(250px,1fr))",
          gap: "12px",
          marginTop: "15px"
        }}
      >
        <input
          placeholder="Title"
          value={form.title} style={{display:"none"}}
          onChange={(e) =>
            setForm({ ...form, title: e.target.value })
          }
        />

        <input
          placeholder="Subtitle"
          value={form.subtitle}  style={{display:"none"}}
          onChange={(e) =>
            setForm({ ...form, subtitle: e.target.value })
          }
        />

        <input
          placeholder="Button Text"  style={{display:"none"}}
          value={form.buttonText}
          onChange={(e) =>
            setForm({ ...form, buttonText: e.target.value })
          }
        />

        <input
          placeholder="Button Link"
          value={form.buttonLink}
          onChange={(e) =>
            setForm({ ...form, buttonLink: e.target.value })
          }
        />

        <select
          value={form.adType}
          onChange={(e) =>
            setForm({ ...form, adType: e.target.value })
          }
        >
          <option value="main">
            Main Slider
          </option>
          <option value="side">
            Side Banner
          </option>
        </select>

        <input
          type="number"
          placeholder="Sort Order"
          value={form.sortOrder}
          onChange={(e) =>
            setForm({
              ...form,
              sortOrder: e.target.value,
            })
          }
        />

       <input
  type="file"
  accept="image/*"
  onChange={(e) =>
    setForm({
      ...form,
      image: e.target.files[0]
    })
  }
/>
{form.image && (
 <img
  src={URL.createObjectURL(form.image)}
  alt=""
  style={{
    width: form.adType === "main" ? "300px" : "220px",
    height: form.adType === "main" ? "180px" : "300px",
    objectFit: "contain",
    borderRadius: "8px",
    marginTop: "10px",
    border: "1px solid #ddd"
  }}
/>
)}
      </div>

      <button
        onClick={saveAd}
        style={{
          marginTop: "15px",
          padding: "10px 20px",
          background: "#1976d2",
          color: "#fff",
          border: "none",
          borderRadius: "6px",
          cursor: "pointer",
        }}
      >
        Save Advertisement
      </button>
    </div>

    {/* Advertisement List */}

    {ads.length === 0 ? (
      <div
        style={{
          color: "#999",
          textAlign: "center",
          padding: "30px",
        }}
      >
        No Advertisement Found
      </div>
    ) : (
      <div
        style={{
          display: "grid",
          gap: "16px",
        }}
      >
        {ads.map((ad) => (
          <div
            key={ad.id}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "20px",
              background: "#fff",
              padding: "15px",
              borderRadius: "10px",
              boxShadow:
                "0 2px 8px rgba(0,0,0,0.08)",
            }}
          >
            <img
              src={ad.imageUrl}
              alt={ad.title}
              style={{
                width: "150px",
                height: "90px",
                objectFit: "cover",
                borderRadius: "6px",
              }}
            />

            <div style={{ flex: 1 }}>
              <h4
                style={{
                  margin: "0 0 8px",
                }}
              >
                {ad.title}
              </h4>

              <p
                style={{
                  margin: "0 0 5px",
                  color: "#666",
                }}
              >
                {ad.subtitle}
              </p>

              <p
                style={{
                  margin: 0,
                  fontSize: "13px",
                  color: "#888",
                }}
              >
                Type: {ad.adType}
              </p>

              <p
                style={{
                  margin: "5px 0 0",
                  fontSize: "13px",
                  color: "#888",
                }}
              >
                Order: {ad.sortOrder}
              </p>
            </div>

            <div
              style={{
                display: "flex",
                gap: "10px",
              }}
            >
              {/* <button
                style={{
                  padding: "8px 14px",
                  background: "#ff9800",
                  color: "#fff",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              >
                Edit
              </button> */}

              <button
                onClick={() =>
                  deleteAd(ad.id)
                }
                style={{
                  padding: "8px 14px",
                  background: "#f44336",
                  color: "#fff",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              >
                Delete
              </button>
            </div>
          </div>
        ))}
      </div>
    )}
            {/* {isMobile && <MobileBottomNav activeTab={activeTab} setActiveTab={setActiveTab} />} */}

  </section>
  </div>
  </>
);
}